import React from "react";
import { Editor } from "primereact/editor";
import "./TextEditor.css";
import { TextEditorHeader } from "./components/TextEditorHeader";

export const TextEditor = ({ value, onTextChange }) => {
  return (
    <Editor
      className="editor"
      value={value}
      onTextChange={onTextChange}
      headerTemplate={<TextEditorHeader />}
    />
  );
};
